import { Navigate, Outlet } from 'react-router-dom'
import { useAppSelector } from '@/redux/hooks'
import { selectors } from './slice'
import type { UserRole } from './types'

interface Props {
  allowedRoles: UserRole[]
}

export function RouteGuard(props: Props) {
  const { allowedRoles } = props
  const userRole = useAppSelector(selectors.selectUserRole)

  if (!allowedRoles.includes(userRole)) {
    return <Navigate to="/search" replace />
  }

  return <Outlet />
}
